export const USER_DEVICE_TYPE = "SW_DEVICE_TYPE";

export enum DEVICE {
  PC = "pc",
  MOBILE = "mobile",
}
